import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const LocationsSection = () => {
  const [activeLocation, setActiveLocation] = useState(0);

  const locations = [
    {
      name: 'Dinslaken',
      subtitle: 'Hauptsitz & Zentrale',
      address: 'Otto-Lilienthal-Straße 43, 46539 Dinslaken',
      phone: '0 2064 777722',
      email: 'ragnadetailing@gmail.com',
      hours: {
        weekdays: 'Mo-Fr: 08:00 - 17:30',
        saturday: 'Sa: 08:00 - 16:00',
        sunday: 'So: Geschlossen'
      },
      coordinates: { lat: 51.5625, lng: 6.7333 },
      mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39680.17987184353!2d6.680792570114115!3d51.56802743036099!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8940caf7de9b7%3A0xca2fb2bf78668081!2sOtto-Lilienthal-Stra%C3%9Fe%2043%2C%2046539%20Dinslaken!5e0!3m2!1sde!2sde!4v1759157141051!5m2!1sde!2sde',
      image: "/assets/images/Generated Image October 04, 2025 - 12_26AM.png",
      features: [
        'Hauptwerkstatt mit 6 Arbeitsplätzen',
        'NANO-Versiegelung Spezialist',
        'Lackiererei vor Ort',
        'Kundenlounge mit WLAN',
        'Kostenlose Parkplätze',
        'Hol- und Bringservice'
      ],
      specialties: ['NANO-Versiegelung', 'Lackreparatur', 'Premium Detailing']
    },
    {
      name: 'Dinslaken',
      subtitle: 'Zweigstelle',
      address: 'Hünxer Straße 131, 46539 Dinslaken',
      phone: '0 2064 777722',
      email: 'ragnadetailing@gmail.com',
      hours: {
        weekdays: 'Mo-Fr: 08:00 - 17:30',
        saturday: 'Sa: 08:00 - 16:00',
        sunday: 'So: Geschlossen'
      },
      coordinates: { lat: 51.5625, lng: 6.7333 },
      mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2478.5!2d6.7333!3d51.5625!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDMzJzQ1LjAiTiA2wrA0NCcwMC4wIkU!5e0!3m2!1sde!2sde!4v1759157141052!5m2!1sde!2sde',
      image: "/assets/images/Generated Image October 04, 2025 - 12_26AM.png",
      features: [
        'Moderne Werkstatt',
        'NANO-Versiegelung',
        'Komplettaufbereitung',
        'Kundenlounge',
        'Kostenlose Parkplätze',
        'Hol- und Bringservice'
      ],
      specialties: ['NANO-Versiegelung', 'Komplettaufbereitung', 'Premium Detailing']
    }
  ];

  const location = locations[activeLocation];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerHeight = 80;
      const elementPosition = element?.getBoundingClientRect()?.top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="locations" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Icon name="MapPin" size={16} />
            <span className="text-sm font-medium">Unsere Standorte</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
            Unsere Standorte
            <span className="block text-primary">in Dinslaken</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Besuchen Sie uns an einem unserer beiden Standorte in Dinslaken für professionelle Autopflege
            mit modernster Ausstattung und erstklassigem Service.
          </p>
        </div>

        {/* Location Selector */}
        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-muted/30 rounded-lg p-1">
            {locations.map((loc, index) => (
              <button
                key={index}
                onClick={() => setActiveLocation(index)}
                className={`px-6 py-3 rounded-md font-medium transition-all duration-300 ${activeLocation === index
                  ? 'bg-primary text-white shadow-md'
                  : 'text-muted-foreground hover:text-foreground'
                  }`}
              >
                {loc.subtitle === 'Hauptsitz & Zentrale' ? 'Otto-Lilienthal-Straße' : 'Hünxer Straße'}
              </button>
            ))}
          </div>
        </div>

        {/* Location Details */}
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Location Info */}
          <div className="space-y-8">
            <div>
              <h3 className="text-3xl font-bold text-foreground mb-2">
                {location?.name}
              </h3>
              <p className="text-xl text-primary font-medium mb-6">
                {location?.subtitle}
              </p>

              {/* Contact Info */}
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <Icon name="MapPin" size={20} className="text-primary mt-1" />
                  <div>
                    <p className="font-medium text-foreground">Adresse</p>
                    <p className="text-muted-foreground">{location?.address}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Icon name="Phone" size={20} className="text-primary mt-1" />
                  <div>
                    <p className="font-medium text-foreground">Telefon</p>
                    <a
                      href={`tel:+49${location?.phone?.replace(/\s/g, '')}`}
                      className="text-primary hover:text-accent transition-colors"
                    >
                      {location?.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Icon name="Mail" size={20} className="text-primary mt-1" />
                  <div>
                    <p className="font-medium text-foreground">E-Mail</p>
                    <a
                      href={`mailto:${location?.email}`}
                      className="text-primary hover:text-accent transition-colors"
                    >
                      {location?.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Opening Hours */}
            <div className="bg-muted/30 rounded-xl p-6">
              <h4 className="font-bold text-foreground mb-4 flex items-center space-x-2">
                <Icon name="Clock" size={20} />
                <span>Öffnungszeiten</span>
              </h4>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Montag - Freitag</span>
                  <span className="font-medium text-foreground">{location?.hours?.weekdays?.split(': ')?.[1]}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Samstag</span>
                  <span className="font-medium text-foreground">{location?.hours?.saturday?.split(': ')?.[1]}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Sonntag</span>
                  <span className="font-medium text-foreground">{location?.hours?.sunday?.split(': ')?.[1]}</span>
                </div>
              </div>
            </div>

            {/* Specialties */}
            <div>
              <h4 className="font-bold text-foreground mb-4">Spezialitäten</h4>
              <div className="flex flex-wrap gap-2">
                {location?.specialties?.map((specialty, index) => (
                  <span
                    key={index}
                    className="bg-accent/10 text-accent px-3 py-1 rounded-full text-sm font-medium"
                  >
                    {specialty}
                  </span>
                ))}
              </div>
            </div>

            {/* Features */}
            <div>
              <h4 className="font-bold text-foreground mb-4">Ausstattung & Service</h4>
              <div className="grid grid-cols-1 gap-3">
                {location?.features?.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <Icon name="Check" size={16} className="text-success" />
                    <span className="text-muted-foreground">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Button
                variant="default"
                className="bg-primary hover:bg-primary/90"
                onClick={scrollToContact}
                iconName="Calendar"
                iconPosition="left"
              >
                Termin buchen
              </Button>
              <Button
                variant="outline"
                onClick={() => window.open(`tel:+49${location?.phone?.replace(/\s/g, '')}`, '_self')}
                iconName="Phone"
                iconPosition="left"
              >
                Anrufen
              </Button>
              <Button
                variant="outline"
                onClick={() => window.open(`https://wa.me/49${location?.phone?.replace(/\s/g, '')}?text=Hallo,%20ich%20möchte%20einen%20Termin%20vereinbaren.`, '_blank')}
                iconName="MessageCircle"
                iconPosition="left"
              >
                WhatsApp
              </Button>
            </div>
          </div>

          {/* Map & Image */}
          <div className="space-y-6">
            {/* Location Image */}
            <div className="relative h-64 rounded-2xl overflow-hidden shadow-card">
              <Image
                src={location?.image}
                alt={`Ragna Detailing ${location?.name}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <h4 className="text-xl font-bold text-white mb-1">
                  Ragna Detailing {location?.name}
                </h4>
                <p className="text-white/90">{location?.subtitle}</p>
              </div>
            </div>

            {/* Google Map */}
            <div className="h-80 rounded-2xl overflow-hidden shadow-card">
              <iframe
                src={location?.mapEmbedUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`Ragna Detailing ${location?.name} - ${location?.address}`}
              />
            </div>

            {/* Quick Contact Card */}
            <div className="bg-gradient-to-r from-primary to-accent rounded-xl p-6 text-white">
              <h4 className="font-bold mb-3">Schnellkontakt {location?.name}</h4>
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <Icon name="Phone" size={16} />
                  <span>{location?.phone}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Mail" size={16} />
                  <span>{location?.email}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;